
module.exports.createState = function()
{
    return {
                fatalError: null,

                applicationMode: "",
                clientId: "",

                applicationId: "",
                applicationTitle: "Jinoby Web Ordering App",
                franchisor: "",
                franchisorId: "",
                franchiseeId: "",
                propertyId: "",
                storefront: null,
                localizationSettings: "",
                tableNumber: "",
                themeId: "",
                favIconUrl: "",
                venueCode: "",
                channel: "",
                allowedDispatchTypes: [],
                doesSupportMultipleProperties: false,
                saleMenuId: "",
                rewardMenuId: "",

                property: null,

                currentMenu: null,
                basketVersion: 0,
                basket: {},

                activeSnoozeProperties: [],

                currentMenuCategoryIndex: -1,
                currentComponent: "",
                currentMode: "",

                token: "",
                
                user: null
           }
}
